import { createIcon } from '../icon'
import ArrowUpIcon from '../svg/ArrowUpIcon'

export const ArrowUpIconDefault = createIcon(ArrowUpIcon)
